
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune/Jeff",
      function () {
        return require("private-next-pages/money-fortune/Jeff.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune/Jeff"])
      });
    }
  